/** Textes de la démo publique — le français fait foi. */
export const demo = {
  lectureSeule: "Démo en lecture seule : rien n'est enregistré. Pour l'essayer avec vos propres données, écrivez-nous.",
  indisponible: "Cet écran n'est pas disponible dans la démo.",
  bandeau: 'Démo en ligne — données fictives, rien n\'est enregistré',
  vous: (role: string) => `Vous êtes : ${role}`,
  changerRole: 'Changer de rôle',
  contacter: 'Contacter le fondateur',
  site: 'Retour au site',
  choisirTitre: 'Visitez Clefo comme si vous étiez dans l\'agence',
  choisirSousTitre: 'Une agence de location fictive, avec trois mois d\'activité. Choisissez qui vous êtes :',
  roles: {
    gerant_finances: { titre: 'Le gérant', texte: 'La caisse du mois, la banque, les dettes, les réglages — tout l\'argent de l\'agence.' },
    gerant: { titre: 'Le responsable', texte: 'Le planning, la flotte, l\'entretien, les validations du comptoir.' },
    agent: { titre: "L'agent de comptoir", texte: 'Les départs et retours du jour, les contrats, les états des lieux, l\'encaissement.' },
  } as Record<string, { titre: string; texte: string }>,
  entrer: 'Entrer',
  langue: 'Voir la démo en English',
};
